import React from 'react';

import ReactSelect from 'react-select';
import AsyncReactSelect from 'react-select/async';
import CreatableReactSelect from 'react-select/creatable';

const defaultProps = {
  classNamePrefix: 'react-select',
  disabled: false,
  openMenuOnFocus: true,
  options: [],
  value: undefined,
};

const Select = ({ disabled, async, creatable, innerRef, ...rest }) => {
  if (async) {
    return <AsyncReactSelect ref={innerRef} isDisabled={disabled} {...rest} />;
  }

  if (creatable) {
    return <CreatableReactSelect ref={innerRef} isDisabled={disabled} {...rest} />;
  }

  return <ReactSelect ref={innerRef} isDisabled={disabled} {...rest} />;
};

Select.defaultProps = defaultProps;
export default Select;
